import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as actions from './redux/actions';
import { connect } from 'react-redux';
import CustomSelect from '../../common/formElements/CustomSelect';
import { ErrorMessage, Form, Formik } from 'formik';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import ParentContentCard from '../common/ParentContentCard';
import ListPages from './pages/ListPages';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import ParentDocCard from '../common/ParentDocCard';
import Layout from './Layout';
import { pageSettingText } from '../../common/docs/content';

class PageSettingsForm extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
  };

  componentDidMount = () => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.loadDefaultPage({ projectId, version });
    actions.loadAppSettingPages({ projectId, version });
  };

  createSchemaForPageSetting = () => {
    const { defaultPage } = this.props.appSetting;
    return {
      defaultPageUuid: defaultPage ? defaultPage.uuid : '',
    };
  };

  pageOptions = () => {
    let options = [{ value: '', label: 'Choose Page' }];
    let pages = this.props.appSetting ? this.props.appSetting.pages : [];
    if (pages.length > 0) {
      options = options.concat(
        pages.map((page) => {
          return { value: page.uuid, label: page.name };
        }),
      );
    }
    return options;
  };

  handleSubmit = (values) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.changeDefaultPage({
      projectId,
      version,
      defaultPageUuid: values.defaultPageUuid,
    });
  };

  render() {
    const { changeDefaultPagePending, appSetting, home, match } = this.props;
    const { projectId, version } = match.params;
    const { pages, defaultPage, layouts, projectDetail } = appSetting;
    const { snippets } = home;

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'pageSetting'} projectDetail={projectDetail} />
        <ParentContentCard title="Default Page" bgColor="drapcode-violet" icon="form">
          <Formik
            enableReinitialize={true}
            initialValues={this.createSchemaForPageSetting()}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              this.handleSubmit(values);
              setSubmitting(false);
              resetForm();
            }}
          >
            {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Default Page">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('select')}`}></i>
                          </span>
                        </div>
                        <CustomSelect
                          name="defaultPageUuid"
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={this.pageOptions()}
                          value={values['defaultPageUuid']}
                          placeholder="Default Page"
                        />
                        <ErrorMessage name={'defaultPageUuid'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                        <div className="input-group-append">
                          <span
                            className="input-group-text"
                            data-tip="Default Page"
                            title="Shows the list of all pages you have created in the web app builder. You can select any page and make it the default page."
                          >
                            <i className={`wb ${drapcodeIcon('description')}`}></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 text-right d-flex justify-content-between">
                    <button
                      type="reset"
                      onClick={() => this.props.toggle('appConstant')}
                      className="btn btn-outline btn-md"
                    >
                      <i className="wb webconnect-times"> </i> Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-theme-submit btn-md"
                      disabled={isSubmitting ? 'disabled' : ''}
                    >
                      <i className={`wb webconnect-plus`}></i> Update&nbsp;
                      <CustomLoader
                        loading={changeDefaultPagePending !== undefined && changeDefaultPagePending}
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
        {/* <Layout projectId={projectId} layouts={layouts} snippets={snippets} /> */}
        <ParentDocCard>
          <h5>
            <b>About Page Setting</b>
          </h5>
          <p>{pageSettingText}</p>
          <br />
        </ParentDocCard>
        <ParentContentCard title="Pages" bgColor="drapcode-violet" icon="pages">
          <ListPages
            projectId={projectId}
            activeTab={'pages'}
            title={'Pages'}
            pages={pages}
            version={version}
            projectDefaultPage={defaultPage}
          />
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageSettingsForm);
